/**
 * Constantes partagées du domaine métier.
 * Ne dépendent d'aucune source de données — toujours en mémoire.
 */

/**
 * Équipements du bien — liste UNIQUE, partagée par la fiche location, la fiche
 * vente et le formulaire de création vente (décision Thibaud 2026-08-09).
 *
 * Avant, chaque fiche avait la sienne : 12 cases en location, 9 en vente. Or
 * les deux écrivent la MÊME colonne `equipements`. Un bien portant « Machine à
 * laver » affichait donc la case cochée côté location et rien du tout côté
 * vente — valeur invisible et impossible à décocher. Une seule liste supprime
 * ce trou.
 *
 * ⚠️ `tag` est la valeur STOCKÉE en base et lue par `EQUIPEMENT_RULES`
 * (lib/immoweb/enums.ts) : ne jamais la traduire ni la renommer, c'est une clé.
 * Seul `labelKey` change d'une langue à l'autre.
 *
 * Note : « Machine à laver » et « Sèche-linge » sont absents de
 * `EQUIPEMENT_RULES`, donc ignorés par le mapper — ils ne partent sur aucun
 * portail. Conservés parce qu'ils décrivent un bien meublé.
 */
export const EQUIPEMENT_TAGS: { tag: string; labelKey: string }[] = [
  { tag: "Cuisine super équipée", labelKey: "biens.equipements.cuisineSuperEquipee" },
  { tag: "Buanderie", labelKey: "biens.equipements.buanderie" },
  { tag: "Machine à laver", labelKey: "biens.equipements.machineALaver" },
  { tag: "Sèche-linge", labelKey: "biens.equipements.secheLinge" },
  { tag: "Concierge", labelKey: "biens.equipements.concierge" },
  { tag: "Ascenseur", labelKey: "biens.equipements.ascenseur" },
  { tag: "Accessible PMR", labelKey: "biens.equipements.accessiblePmr" },
  { tag: "Parlophone", labelKey: "biens.equipements.parlophone" },
  { tag: "Interphone vidéo", labelKey: "biens.equipements.interphoneVideo" },
  { tag: "Porte blindée", labelKey: "biens.equipements.porteBlindee" },
  { tag: "Câble TV", labelKey: "biens.equipements.cableTv" },
  { tag: "Piscine", labelKey: "biens.equipements.piscine" },
  { tag: "Double vitrage", labelKey: "biens.equipements.doubleVitrage" },
  // Ajouté 2026-09-14 : `intruderAlarm` (Immoweb) affiche "Non" côté WHISE
  // sans case correspondante ici pour dire "Oui" — impossible à cocher avant.
  { tag: "Alarme", labelKey: "biens.equipements.alarme" },
];

export const METIER_BADGE_COLORS: Record<string, string> = {
  "Nettoyage": "bg-accent-light text-accent",
  "Expert PEB": "bg-success-light text-success",
  "Photos - Vidéos": "bg-[#DBEAFE] text-[#3B82F6]",
  "Réparations": "bg-danger-light text-danger",
  "Certificat Elec": "bg-success-light text-success",
};
